import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  ListGroup,
  ListGroupItem,
  Pagination,
  Row,
  Spinner,
} from "react-bootstrap";
import { useMutation, useQuery } from "@apollo/client";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import { getDownloadURL, getStorage, ref } from "firebase/storage";

import Flex from "../../../components/common/Flex";
import dummyImg from "../../../assets/img/placeholders/image-placeholder.jpg";
import dummyFile from "../../../assets/img/placeholders/file-placeholder.png";
import ReportDetailModal from "../../../components/reportDetailModal";
import PATH from "../../../routes/RoutePath";
import QUERY from "../../../utils/service/query";
import { usePagination } from "../../../utils/usePagination";

const ReportDetail: React.FC = () => {
  const { reportId } = useParams();
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [page, setPage] = useState(1);
  const [pageTmp, setPageTmp] = useState(page);

  const { data } = useQuery(QUERY.REPORTS.GET_REPORT, {
    variables: { reportId: reportId },
  });
  const res = useQuery(QUERY.REPORTS.GET_REPORTED_CLIP, {
    variables: { reportId: reportId },
  });
  const [updateReport] = useMutation(QUERY.REPORTS.REPORT_STATUS_ACTION);

  const res1 = useQuery(QUERY.REPORTS.GET_ACTIVITY_LOG, {
    variables: { clipId: res?.data?.getReportedClip?.id, page: page },
  });

  const [isLoading, setIsLoading] = useState(false);
  const [urlImg, setUrlImg] = useState("");
  const [urlVideo, setUrlVideo] = useState("");
  const [urlFile, setUrlFile] = useState("");

  const getMediaUrl = async (url: string) => {
    if (!url) return null;
    setIsLoading(true);
    const storage = getStorage();
    const imgRef = ref(storage, url);

    const videoExt = ["mp4", "mov", "avi"];
    const imageExt = ["jpeg", "jpg", "png"];
    try {
      const URL = await getDownloadURL(imgRef);
      const fileExt = url?.split(".").at(url.split(".").length - 1) || "";
      if (fileExt) {
        if (videoExt?.indexOf(fileExt) !== -1) {
          setUrlVideo(URL);
        } else if (imageExt?.indexOf(fileExt) !== -1) {
          setUrlImg(URL);
        } else {
          setUrlFile(URL);
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  // const getMediaUrl = (url: string) => {
  //   setIsLoading(true);
  //   const storage = getStorage();
  //   const imgRef = ref(storage, url);

  //   const videoExt = ["mp4", "mov", "avi"];
  //   const imageExt = ["jpeg", "jpg", "png"];

  //   getDownloadURL(imgRef)
  //     .then((URL) => {
  //       const fileExt = url?.split(".").at(url.split(".").length - 1) || "";

  //       if (fileExt) {
  //         if (videoExt?.indexOf(fileExt) !== -1) {
  //           setUrlVideo(URL);
  //         } else if (imageExt?.indexOf(fileExt) !== -1) {
  //           setUrlImg(URL);
  //         } else {
  //           setUrlFile(URL);
  //         }
  //       }
  //       setIsLoading(false);
  //       return URL;
  //     })
  //     .catch((error) => {
  //       setIsLoading(false);
  //     });
  //   setIsLoading(false);
  //   return dummyImg;
  // };

  useEffect(() => {
    res?.data?.getReportedClip?.mediafile &&
      getMediaUrl(res?.data?.getReportedClip?.mediafile);
    res?.data?.getReportedClip?.medias?.length > 0 &&
      getMediaUrl(
        res?.data?.getReportedClip?.medias[0]?.mediaPath ||
          res?.data?.getReportedClip?.medias[0]?.mediafile ||
          "",
      );
  }, [
    res?.data?.getReportedClip?.medias,
    res?.data?.getReportedClip?.mediafile,
  ]);

  const paginationRange = usePagination({
    currentPage: page,
    totalCount: res1?.data?.activityLogsList?.totalCount || 1,
    siblingCount: 1,
    pageSize: res1?.data?.activityLogsList?.limit || 1,
  });

  return (
    <>
      <Card className="mb-3">
        <Card.Header>
          <h5>Report ID : {data?.getOneReport?.reportId || "N/A"}</h5>
        </Card.Header>
        <Card.Body className="bg-light">
          <Flex justifyContent={"end"}>
            {/* <Link to={PATH.REPORTS.REPORTS_LIST}> */}
            <Button className="" size="sm" onClick={() => navigate(-1)}>
              Back To List
            </Button>
            {/* </Link> */}
            {!res?.data?.getReportedClip?.isArchived && (
              <>
                <Button
                  className="mx-2"
                  size="sm"
                  onClick={(e) => {
                    e.preventDefault();
                    updateReport({
                      onCompleted: res1.refetch,
                      refetchQueries: [
                        {
                          fetchPolicy: "no-cache",
                          query: QUERY.REPORTS.GET_REPORT,
                          variables: { reportId: reportId },
                        },
                        {
                          fetchPolicy: "no-cache",
                          query: QUERY.REPORTS.GET_ACTIVITY_LOG,
                          variables: {
                            clipId: res?.data?.getReportedClip?.id,
                            page: page,
                          },
                        },
                      ],
                      variables: {
                        status: "Correct",
                        reportId: reportId,
                      },
                    })
                      .then(() => {
                        toast.success("Report Status updated successfully");
                      })
                      .catch(() => {
                        toast.error("Something went wrong!");
                      });
                  }}
                  disabled={
                    data?.getOneReport?.status === "Correct" ? true : false
                  }>
                  Mark as Correct
                </Button>
                <Button
                  className=""
                  size="sm"
                  onClick={(e) => {
                    e.preventDefault();
                    updateReport({
                      onCompleted: res1.refetch,
                      refetchQueries: [
                        {
                          fetchPolicy: "no-cache",
                          query: QUERY.REPORTS.GET_ACTIVITY_LOG,
                          variables: {
                            clipId: res?.data?.getReportedClip?.id,
                            page: page,
                          },
                        },
                        {
                          fetchPolicy: "no-cache",
                          query: QUERY.REPORTS.GET_REPORT,
                          variables: { reportId: reportId },
                        },
                      ],
                      variables: {
                        status: "Incorrect",
                        reportId: reportId,
                      },
                    })
                      .then(() => {
                        toast.success("Report Status updated successfully");
                      })
                      .catch(() => {
                        toast.error("Something went wrong!");
                      });
                  }}
                  disabled={
                    data?.getOneReport?.status === "Incorrect" ? true : false
                  }>
                  Mark as Incorrect
                </Button>
              </>
            )}
          </Flex>
          <Card style={{ marginTop: "16px" }}>
            <Flex>
              {urlImg && !isLoading && (
                <Card.Img
                  src={urlImg}
                  variant="top"
                  style={{ width: "200px", maxHeight: "150px" }}
                />
              )}
              {urlVideo && (
                <video
                  width="200"
                  height="150"
                  style={{ borderRadius: "01rem", padding: "10px" }}
                  autoPlay
                  muted>
                  <source src={urlVideo} type="video/mp4" />
                </video>
              )}
              {urlFile && (
                <Card.Img
                  src={dummyFile}
                  variant="top"
                  style={{ width: "200px", maxHeight: "150px" }}
                />
              )}
              {!res?.data?.getReportedClip?.medias?.length &&
                !res?.data?.getReportedClip?.mediafile &&
                !urlImg &&
                !urlVideo &&
                !urlFile &&
                !isLoading &&
                !res?.loading && (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ width: "200px", borderRadius: "0.375rem" }}>
                    No Media
                  </div>
                )}
              {(res?.loading || isLoading) && (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ width: "200px", borderRadius: "0.375rem" }}>
                  Loading
                </div>
              )}

              <Card.Body>
                <Card.Title>
                  {res?.data?.getReportedClip?.text || "No Text Found"}
                </Card.Title>
                <Card.Text>
                  <b style={{ marginRight: "32px" }}>
                    {res?.data?.getReportedClip?.createdOn
                      ? moment(res?.data?.getReportedClip?.createdOn)
                          .tz("Australia/Brisbane")
                          .format("DD-MM-YYYY, h:mm A")
                      : "N/A"}
                  </b>
                  <b>
                    {(res?.data?.getReportedClip?.medias?.length > 1 &&
                      "Multiple Files") ||
                      (res?.data?.getReportedClip?.medias?.length === 1 &&
                        "Single File") ||
                      (res?.data?.getReportedClip?.mediafile &&
                        "Single File") ||
                      ""}
                  </b>
                </Card.Text>
                {/* <Card.Text>
									{data?.getOneReport?.clip?.description.slice(0, 340) +
										(data?.getOneReport?.clip?.description.length > 337
											? "..."
											: "") || ""}
								</Card.Text> */}
                <Button onClick={() => setModalShow(true)}>View</Button>
              </Card.Body>
            </Flex>
          </Card>
        </Card.Body>
      </Card>
      <Card className="mb-3">
        <Card.Header>
          <h5>Report Details</h5>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col lg={3} className="mb-3">
              <Card.Text className="m-0">
                <b>Reported Date</b>
              </Card.Text>
              <Card.Text className="m-0">
                {moment(data?.getOneReport?.createdOn)
                  .tz("Australia/Brisbane")
                  .format("DD-MM-YYYY") || "N/A"}
              </Card.Text>
            </Col>
            <Col lg={3} className="mb-3">
              <Card.Text className="m-0">
                <b>Reported Time</b>
              </Card.Text>
              <Card.Text className="m-0">
                {moment(data?.getOneReport?.createdOn)
                  .tz("Australia/Brisbane")
                  .format("h:mm A") || "N/A"}
              </Card.Text>
            </Col>
            <Col lg={3} className="mb-3">
              <Card.Text className="m-0">
                <b>Reporter</b>
              </Card.Text>
              <Card.Text className="m-0">
                {data?.getOneReport?.reporter?.uid ? (
                  <Link
                    to={
                      PATH.USERS.USER_PROFILE +
                      data?.getOneReport?.reporter?.uid
                    }>
                    @{data?.getOneReport?.reporter?.displayName}
                  </Link>
                ) : (
                  "N/A"
                )}
              </Card.Text>
            </Col>
            <Col lg={3} className="mb-3">
              <Card.Text className="m-0">
                <b>Reportee</b>
              </Card.Text>
              <Card.Text className="m-0">
                {data?.getOneReport?.reportee?.uid ? (
                  <Link
                    to={
                      PATH.USERS.USER_PROFILE +
                      data?.getOneReport?.reportee?.uid
                    }>
                    @{data?.getOneReport?.reportee?.displayName || ""}
                  </Link>
                ) : (
                  "N/A"
                )}
              </Card.Text>
            </Col>
            <Col lg={12} className="mb-3">
              <Card.Text className="m-0">
                <b>Reason</b>
              </Card.Text>
              <Card.Text className="m-0">
                {data?.getOneReport?.reason ||
                  data?.getOneReport?.otherText ||
                  ""}
              </Card.Text>
              {/* <Card.Text className="m-0">
                {moment().tz("Australia/Brisbane").format("h:mm A") || "N/A"}
              </Card.Text> */}
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card>
        <Card.Header>
          <h5>Log</h5>
        </Card.Header>
        <Card.Body>
          <ListGroup className="list-group-flush">
            {res1?.data?.activityLogsList?.list &&
              res1?.data?.activityLogsList?.list.map(
                (item: any, index: number) => (
                  <ListGroupItem key={`${item?.action}${index}`}>
                    <Row>
                      <Col lg={1}>{index + 1}</Col>
                      <Col lg={6}>
                        {item?.action}
                        <br />
                        {item?.metaData?.reportIds &&
                          item?.metaData.reportIds.length > 0 && (
                            <span>
                              Report ID
                              {item?.metaData?.reportIds.length > 1
                                ? "s"
                                : ""}:{" "}
                              {item?.metaData?.reportIds.map((item: any) => (
                                <Link
                                  to={PATH.REPORTS.REPORT_DETAILS + item?.id}
                                  style={{ marginRight: "8px" }}>
                                  {item?.reportId}{" "}
                                </Link>
                              ))}
                            </span>
                          )}
                        {!item?.metaData?.reportIds && item?.reportId && (
                          <span className="">
                            Report ID:{" "}
                            <Link
                              to={
                                PATH.REPORTS.REPORT_DETAILS + item?.reportId?.id
                              }>
                              {item?.reportId?.reportId}
                            </Link>
                          </span>
                        )}
                      </Col>
                      <Col lg={3}>
                        {moment(item?.createdOn)
                          .tz("Australia/Brisbane")
                          .format("DD-MM-YYYY") || "N/A"}
                      </Col>
                      <Col lg={2}>
                        {moment(item?.createdOn)
                          .tz("Australia/Brisbane")
                          .format("h:mm A") || "N/A"}
                      </Col>
                    </Row>
                  </ListGroupItem>
                ),
              )}
            {res1?.data?.activityLogsList?.list.length === 0 && (
              <ListGroupItem>
                <Row>
                  <Col lg={6}>No Logs</Col>
                </Row>
              </ListGroupItem>
            )}
            {res1.loading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </ListGroup>
        </Card.Body>
        <Card.Footer>
          <Pagination
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <div style={{ display: "flex" }}>
              {paginationRange?.map((p: any) => (
                <Pagination.Item
                  onClick={() => {
                    p !== "..." && setPage(parseInt(p));
                  }}
                  active={page === p ? true : false}>
                  {p}
                </Pagination.Item>
              ))}
            </div>
            <div style={{ display: "flex", width: "146px" }}>
              <Form.Label
                className="mb-0 mx-2"
                style={{ flex: "1 1 1", width: "150px" }}>
                Go to Page
              </Form.Label>
              <Form.Control
                size="sm"
                as="input"
                style={{ width: "50px !important" }}
                value={pageTmp}
                onKeyPress={(e) => {
                  if (e.code === "Enter") {
                    pageTmp <=
                    Math.ceil(
                      (res1?.data?.activityLogsList?.totalCount || 1) /
                        (res1?.data?.activityLogsList?.limit || 1),
                    )
                      ? setPage(Number(pageTmp))
                      : setPageTmp(page);
                  }
                }}
                onChange={(e: any) => {
                  setPageTmp(e.target.value);
                }}
              />
            </div>
            <div>
              <Button
                className="mx-1"
                variant={page > 1 ? "primary" : "light"}
                onClick={
                  page > 1
                    ? () => setPage((prevState) => prevState - 1)
                    : () => {}
                }>
                Previous
              </Button>
              <Button
                variant={
                  page <
                  Math.ceil(
                    (res1?.data?.activityLogsList?.totalCount || 1) /
                      (res1?.data?.activityLogsList?.limit || 1),
                  )
                    ? "primary"
                    : "light"
                }
                onClick={
                  page <
                  Math.ceil(
                    (res1?.data?.activityLogsList?.totalCount || 1) /
                      (res1?.data?.activityLogsList?.limit || 1),
                  )
                    ? () => setPage((prevState) => prevState + 1)
                    : () => {}
                }>
                Next
              </Button>
            </div>
          </Pagination>
        </Card.Footer>
      </Card>
      <ReportDetailModal
        data={res?.data?.getReportedClip}
        modalShow={modalShow}
        setModalShow={setModalShow}
      />
    </>
  );
};

export default ReportDetail;
